module.exports = new __parcel__URL__("jpd-portfolio-management-intake-dark.9e658e8b.svg").toString();